import { ResultDto } from 'svila-common';

interface ResultDtoDisplayProps {
  result: ResultDto | null;
}

export default function ResultDtoDisplay({ result }: ResultDtoDisplayProps): JSX.Element {
  return (
    <>
      {result && (
        <div style={{ backgroundColor: result?.result ? '#c5edca' : '#ffe3e0', padding: 10 }}>
          <h3>{result?.result ? 'Success' : 'Error'}</h3>
          <div>
            <pre>{result?.message}</pre>
          </div>
        </div>
      )}
    </>
  );
}
